import React, { FC } from "react";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import useSelection from "./useSelection";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 240,
  height: 20,
  position: "relative",
  top: -25,
}));

interface SelectionProps {
  chosenConfig?: string;
  isWeirdSixteenRange?: boolean;
  setIsPocketAllowed?: (isAllowed: boolean) => void;
  setFivePanel16?: (isFivePanel: boolean) => void;
  selectedConfig?: (config: string) => void;
  typeRequired: string;
  displayedConfig?: string[];
  netWidth?: number;
}

const Selection: FC<SelectionProps> = ({
  chosenConfig,
  selectedConfig,
  typeRequired,
  displayedConfig = [],
  netWidth = 0
}) => {
  const {
    qty,
    qtyOptions,
    handleChange,
    isLargePanel,
  } = useSelection(selectedConfig || null, netWidth);
  const { readOnly } = useIsReadOnlyContextProviderContext();

  const configs =
    displayedConfig?.length ?
    displayedConfig.map((option, index) => (
      <MenuItem key={index} value={option}>
        {isLargePanel(option)}
      </MenuItem>
    ))
    : <MenuItem />

  return (
    <div style={{ height: 50 }}>
      <StyledFormControl
        required={typeRequired === "config" ? true : false}
        variant="outlined"
      >
        <InputLabel>
          {typeRequired === "unitSize"
            ? "fraction"
            : typeRequired === "config"
              ? "Configuration"
              : "Quantity"}
        </InputLabel>

        {typeRequired === "config" && (
          <Select
            value={chosenConfig}
            onChange={handleChange}
            name="configuration"
            style={{ backgroundColor: "white" }}
            label={typeRequired === "config" ? "Configuration" : "Quantity"}
            readOnly={readOnly}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {configs}
          </Select>
        )}
        {typeRequired === "quantity" && (
          <Select
            value={String(qty)}
            onChange={handleChange}
            name="quantity"
            label="Quantity"
            readOnly={readOnly}
          >
            {qtyOptions.map((num) => (
              <MenuItem key={num} value={num}>
                {num}
              </MenuItem>
            ))}
          </Select>
        )}

        {typeRequired === "quantity" ? null : (
          <FormHelperText>Required</FormHelperText>
        )}
      </StyledFormControl>
    </div>
  );
};

export default Selection;
